export function isAllowedAmountKey(event: KeyboardEvent): boolean {
    const allowedKeys = [
        'Backspace',
        'Delete',
        'Tab',
        'Escape',
        'Enter',
        'ArrowLeft',
        'ArrowRight',
        'Home',
        'End'
    ];

    if (allowedKeys.includes(event.key)) return true;

    if (event.ctrlKey || event.metaKey) return true;

    return /^[0-9.]$/.test(event.key);
}

export function cleanAmountInput(value: string): string {
    return value
        .replace(/,/g, '')
        .replace(/[^\d.]/g, '')
        .replace(/(\..*)\./g, '$1');
}

export function formatAmountInput(value: string): string {
    const clean = cleanAmountInput(value);
    if (!clean) return '';
    const [whole, fraction] = clean.split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fraction === undefined ? grouped : `${grouped}.${fraction.slice(0, 2)}`;
}
